import GeminiScrollBar from 'gemini-scrollbar';
import 'gemini-scrollbar/gemini-scrollbar.css';

import {
    timePeriodsSelector,
    projectsSelector as projectsScopeSelector
} from '../../../selectors/base';

import { editModeSelector } from '../../../selectors/settings';

import {
    projectsSelector,
    timePeriodSelector,
    projectSelector,
    pageSelector,
    countSelector,
    summarySelector,
    activitiesSelector,
    sizeSelector,
    timePeriodInfoSelector,
    activityTypeIdsSelector,
    loadingSelector,
    uploadingSelector,
    selectedSummariesSelector,
    stopScrollSelector
} from './../../../selectors/activity';

export default class ActivityController {
    static $inject = ['$element', '$timeout', '$scope', '$ngRedux', 'ActivityActions', '$filter', 'processDetailsModalService', 'consts', 'statuses'];
    constructor($element, $timeout, $scope, $ngRedux, ActivityActions, $filter, processDetailsModalService, consts, statuses) {
        'ngInject';
        this.$element = $element;
        this.$timeout = $timeout;
        this.$filter = $filter;
        this.m_processDetailsModalService = processDetailsModalService;
        this.$scope = $scope;
        this.loadInitialDataLoad = false;
        this.consts = consts;
        this.statuses = statuses;
        this.unsubscribe = $ngRedux.connect(mapStateToThis, ActivityActions)(this);
        this.customDate = { startDate: null, endDate: null };
        this.datePickerOptions = {
            eventHandlers: {
                'apply.daterangepicker': () => {
                    const start = this.customDate.startDate.valueOf();
                    const end = this.customDate.endDate.valueOf();
                    const customPeriod = this.timePeriods.find(t => t.custom);
                    this.loadInitialDataLoad = true;
                    return this.loadInitialData({ ...this.options, timePeriod: customPeriod, start, end, page: 1 });
                }
            }
        }
        this.scrollUpdating = false;
    }

    get options() {
        let start, end;
        const { project, projects, activityTypeIds, count, page, timePeriod } = this;
        const pIds = projects.slice(1).map(item => { return item.id; });
        const projectIds = project.selectAll ? pIds : [project.id];
        if (timePeriod.custom) {
            start = this.timePeriodInfo.start;
            end = this.timePeriodInfo.end;
        } else {
            end = Date.now();
            start = end - timePeriod.periodInMilliseconds;
        }

        return { projectIds, activityTypeIds, page, count, timePeriod, start, end };
    }

    get isDisabled() {
        return this.uploading || this.stopScroll || this.loading || this.scrollUpdating;
    }

    $onInit() {
        const _this = this;
        this.scrollContainer = this.$element.find('#activity-scroll-container');
        const scrollableContent = this.scrollContainer.find('[infinite-scroll]');
        this.scrollUpdating = true;
        this.loadInitial({ ...this.options, page: 1 });

        this.$timeout(() => {
            this.scrollbar = new GeminiScrollBar({
                element: this.$element[0].querySelector('.activity-list'),
                autoshow: true,
                createElements: false
            }).create();
            this.scrollUpdating = false;
        });
        this.activitiesWatcher = this.$scope.$watch(() => this.activities.length, (newValue, oldValue) => {

            if (newValue !== oldValue || _this.loadInitialDataLoad) {
                _this.loadInitialDataLoad = false;
                _this.scrollUpdating = true;
                _this.$timeout(() => {
                    _this.scrollbar.update()
                    _this.scrollUpdating = false;
                });
            }
        });
        this.watchScroll = this.$scope.$watch(() => !this.stopScroll && this.scrollContainer.height() >= this.scrollContainer.find('[infinite-scroll]').height(), (newValue, oldValue) => {
            if (newValue) {
                _this.onScroll();
            }
        });
    }

    $onDestroy() {
        this.unsubscribe();
        this.watchScroll();
        this.$timeout(() => {
            this.scrollbar.destroy();
        });
    }
    onActivityShowDetailsClick(item) {
        const activityIcon = this.getCorrespondingStatusIcon(item.type)
        if (item.jobQId != null) {
            this.m_processDetailsModalService.OpenProcessDetailsModal({ activityIcon: activityIcon, JobQId: item.jobQId }, true)
        }
    }
    onProjectSelected(item) {
        const options = this.options;
        this.loadInitialDataLoad = true;
        const { project, projects, activityTypeIds, count, page, timePeriod } = this;
        const pIds = projects.slice(1).map(item => { return item.id; });
        this.loadInitialData({ ...options, page: 1, projectIds: item.selectAll ? pIds : [item.id] });
    }

    onTimePeriodSelected(timePeriod) {
        if (timePeriod.custom) {
            this.$element.find('#activity-datepicker').click();
        } else {
            this.loadInitialDataLoad = true;
            this.loadInitialData({ ...this.options, timePeriod, page: 1 });
        }
    }

    onSummaryToggle(id) {
        const options = this.options;
        options.page = 1;
        options.activityTypeIds = options.activityTypeIds.indexOf(id) === -1 ? [...options.activityTypeIds, id] : options.activityTypeIds.filter(o => o !== id);
        this.loadInitialData({ ...options, page: 1 });
    }
    getCorrespondingStatusIcon = (type) => {
        const activityType = this.consts.activityType;
        switch (type) {
            case activityType.Success:
                return this.statuses["5"].Icon;
            case activityType.Warning:
                return this.statuses["6"].Icon;
            case activityType.Failure:
                return this.statuses["3"].Icon;
        }
    };
    loadInitialData(options) {
        this.scrollContainer[0].scrollTop = 0;
        this.loadInitial(options);
    }
    parseEnvirmentStageName(activity) {
        const paramActiviyItem = activity.details.split(" ");
        const paramStageName = paramActiviyItem[1];

        //check for upgrade with "__Rollback" and change it to Rollback Execution 
        let isRollbackExe1 = "";
        if(activity.versionName)
            isRollbackExe1= activity.versionName.split("__")
        let isRollbackExe2 = "";
        if(isRollbackExe1.length > 1)
            isRollbackExe2= isRollbackExe1[1].split("_");
        let stageName = "";
        if(isRollbackExe2.length > 0 && isRollbackExe2[0] === "Rollback")
            stageName = "Rollback Execution"
        else
            stageName = this.$filter('changeEnumJobNameToName')(paramStageName);
        return stageName;
    }
    onScroll() {
        if (this.isDisabled) {
            return;
        }
        const options = this.options;
        options.page = options.page + 1;
        this.loadAdditional({ ...options });
    }

    convertUTCDateToLocalDate(date) {
        return moment.utc(date, 'DD/MM/YYYY HH:mm:ss').local().toDate().toLocaleString();
    }
}

function mapStateToThis(state) {
    const obj = {
        projectScope: projectsScopeSelector(state),
        projects: projectsSelector(state),
        project: projectSelector(state),
        timePeriods: timePeriodsSelector(state),
        timePeriod: timePeriodSelector(state),
        page: pageSelector(state),
        count: countSelector(state),
        editMode: editModeSelector(state),
        summary: summarySelector(state),
        activities: activitiesSelector(state),
        size: sizeSelector(state),
        timePeriodInfo: timePeriodInfoSelector(state),
        activityTypeIds: activityTypeIdsSelector(state),
        loading: loadingSelector(state),
        uploading: uploadingSelector(state),
        selectedSummaries: selectedSummariesSelector(state),
        stopScroll: stopScrollSelector(state)
    };
    return obj
}



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/components/widgets/activity/activity.controller.js